module.exports = __webpack_public_path__ + "static/icons/icon-resort-guide-3c4630982433801641a62d4c3b7400a9.svg";